import { createContext, useContext, type ReactNode } from 'react';
export const AuditNavigation = createContext<(id: string) => void>(() => {});
export function AuditLink({ id }: { id: string }) {
  const open = useContext(AuditNavigation);
  return (
    <button
      className="link audit-link"
      onClick={() => open(id)}
      aria-label={`İşlem kaydını aç: ${id}`}
    >
      {id} ↗
    </button>
  );
}
export function ResultMessage({ children }: { children: ReactNode }) {
  if (typeof children !== 'string') return <>{children}</>;
  const match = /İşlem kaydı: ([\w-]+)/.exec(children);
  if (!match) return <>{children}</>;
  return (
    <>
      {children.slice(0, match.index)}İşlem kaydı: <AuditLink id={match[1]!} />
      {children.slice(match.index + match[0].length)}
    </>
  );
}
/** api.ts bazı eski mutasyonları unknown döndürür; olmayan auditId uydurulmaz. */
export const auditSuffix = (result: unknown) => {
  if (!result || typeof result !== 'object') return '';
  const audit =
    'auditId' in result && typeof result.auditId === 'string'
      ? ` İşlem kaydı: ${result.auditId}`
      : '';
  const warning =
    'warning' in result && typeof result.warning === 'string' ? ` Uyarı: ${result.warning}` : '';
  return audit + warning;
};
